import { useEffect, useState } from "react";

import { fetchData } from "../utils";
import Loader from "./Loader";

const Wspolpraca = () => {
    const [content, setContent] = useState('')
    const [formData, setFormData] = useState({
        name: '',
        email: '', 
        message: '',
        phoneNumber: ''
    })
    const [loading, setLoading] = useState(true)
    
    useEffect(() => {
        fetchData('pageContent/wspolpraca', 'GET', null, (data) => {
            setContent(data)
            setLoading(false)
        })
    }, [])

    const handleChange = (e) => {
        const {name, value} = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        fetchData('email/send-email', 'POST', formData, (res) => {
            if (res.message) {
                alert(res.message)
            } else {
                alert('Не удалось отправить')
            }
        })
    }

    if (loading) return <Loader/>

    return (
        <div className="container-wsp">
            <div className="wsp-text">
                <h2 className="text-centre">
                    {content.Zaproszenie}
                </h2>
                <div className="text-container-wsp">
                    <span>
                        {content.opisZaproszenia}
                    </span>
                    <div>
                        {content.ofertaSkierowana}
                    </div>
                    <ul>
                        <li>
                            {content.doKogo1}
                        </li>
                        <li>
                            {content.doKogo2}
                        </li>
                        <li>
                            {content.doKogo3}
                        </li>
                        <li>
                            {content.doKogo4}
                        </li>
                    </ul>
                    <h4>
                        {content.CoZapewniamy}
                    </h4>
                    <ul className="coZapew">
                        <li>
                            {content.CoZapewniamy1}
                        </li>
                        <li>
                            {content.CoZapewniamy2}
                        </li>
                        <li>
                            {content.CoZapewniamy3} 
                        </li>
                        <li>
                            {content.CoZapewniamy4}
                        </li>
                        <li>
                            {content.CoZapewniamy5}
                        </li>
                    </ul>
                    <div>
                        <span>
                            {content.skontaktowac}
                        </span>
                    </div>
                </div>
            </div>
            <div className="wsp-block-form">
                <h2 className="just-centre">
                    Nawiążmy współpracę
                </h2>
                <form className="wsp-form" onSubmit={handleSubmit}>
                    <input 
                        className=""
                        name="name" 
                        type="text" 
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Twoje imię"
                        maxLength={50}
                        required/>
                    <input 
                        className="wsp-email"
                        name="email" 
                        type="email" 
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Twój e-mail"
                        required/>
                    <input 
                        className=""
                        type="tel" 
                        name="phoneNumber" 
                        value={formData.phoneNumber}
                        placeholder="Twój numer telefonu (opcjonalnie)"
                        onChange={handleChange}/>
                    <textarea 
                        className=""
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Wiadomość"
                        maxLength={300}
                        required/>
                    <button className="personal-white" type="submit">
                        <span className="z-i-2">
                            Wyślij wiadomość
                        </span>
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Wspolpraca;